<template>
  <a-card :bordered="false">
    <!-- 查询区域 -->
    <div class="table-page-search-wrapper">
      <a-form layout="inline" @keyup.enter.native="searchQuery">
        <a-row :gutter="24">
          <a-col :md="6" :sm="8">
            <a-form-item label="权益名称">
              <a-input
                placeholder="请输入权益名称"
                v-model="searchObj.name"
              ></a-input>
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="8">
            <a-form-item label="权益分类">
              <a-select
                style="width: 155px"
                placeholder="请选择权益分类"
                v-model="searchObj.benefitType"
              >
                <a-select-option v-for="item in benefitTypeOptions" :key="item.value" :value="item.value">{{item.text}}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="8">
            <a-form-item label="可见状态">
              <a-select
                style="width: 155px"
                placeholder="请选择可见状态"
                v-model="searchObj.status"
              >
                <a-select-option value="0">可见</a-select-option>
                <a-select-option value="1">不可见</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="8">
            <span style="float: left; overflow: hidden" class="table-page-search-submitButtons">
              <a-button type="primary" @click="searchQuery" icon="search">查询</a-button>
              <a-button type="primary" @click="searchReset" icon="reload" style="margin-left: 8px" >重置</a-button>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <!-- 查询区域-END -->

    <!-- 操作按钮区域 -->
    <div class="table-operator">
      <a-button @click="handleAdd" type="primary" icon="plus">添加权益</a-button>
    </div>

    <!-- table区域-begin -->
    <div>
      <a-table
        ref="table"
        size="middle"
        :scroll="{x:true}"
        bordered
        rowKey="id"
        :columns="columns"
        :dataSource="dataSource"
        :pagination="ipagination"
        :loading="loading"
        :rowSelection="{selectedRowKeys: selectedRowKeys, onChange: onSelectChange}"
        class="j-table-force-nowrap"
        @change="handleTableChange">
        <template slot="iconSlot" slot-scope="text, record, index">
          <div class="anty-img-wrap">
            <a-avatar
              shape="square"
              :src="getIconView(record.icon)"
              icon="pie-chart"
            />
          </div>
        </template>
        <template slot="statusFlg" slot-scope="val,record">
          <a-switch
            v-model="record.statusFlg"
            checked-children="可见"
            un-checked-children="不可见"
            @click="checked => handleStatusArticle(checked, record)"
          />
        </template>
        <span slot="action" slot-scope="text, record">
          <a @click="handleEdit(record)">编辑</a>
          <a-divider type="vertical" />
          <a-popconfirm
            title="确定删除吗?"
            @confirm="() => handleDelete(record.id)"
          >
            <a>删除</a>
          </a-popconfirm>
        </span>

      </a-table>
    </div>

    <equity-pool-modal ref="modalForm" :benefitTypeOptions="benefitTypeOptions" @ok="modalFormOk"></equity-pool-modal>
  </a-card>
</template>

<script>

  import '@/assets/less/TableExpand.less'
  import { filterObj } from '@/utils/util';
  import EquityPoolModal from './modules/EquityPoolModal'
  import { getAction, postAction, getFileAccessHttpUrl } from '@/api/manage';
  import {initDictOptions,filterDictTextByCache} from '@/components/dict/JDictSelectUtil';
  const columns = [
    {
      title:'排序',
      align:"center",
      dataIndex: 'idx'
    },
    {
      title:'权益分类',
      align:"center",
      dataIndex: 'benefitType',
      customRender:function (text) {
        console.log(text)
        return filterDictTextByCache('benefit_type',text);
      }
    },
    {
      title:'权益名称',
      align:"center",
      dataIndex: 'name'
    },
    {
      title:'权益说明',
      align:"center",
      dataIndex: 'description'
    },
    {
      title:'icon',
      align:"center",
      dataIndex: 'icon',
      scopedSlots: {
        customRender: 'iconSlot'
      },
    },
    {
      title:'是否可见',
      align:"center",
      dataIndex: 'statusFlg',
      ellipsis: true,
      scopedSlots: {
        customRender: 'statusFlg'
      },
    },
    {
      title: '操作',
      dataIndex: 'action',
      align:"center",
      fixed:"right",
      width:147,
      scopedSlots: { customRender: 'action' }
    }
  ];
  export default {
    name: 'EquityPoolList',
    components: {
      EquityPoolModal
    },
    data () {
      return {
        description: '权益池管理页面',
        //--------列表页重复代码 start-------------
        searchObj: {
          name: undefined,
          benefitType: undefined,
          status:undefined
        },
        /* table选中keys*/
        selectedRowKeys: [],
        loading: false,
        queryParam: {
          custType: '',
          realName: ''
        },
        dataSource: [],
        ipagination: {
          current: 1,
          pageSize: 10,
          pageSizeOptions: ['10', '20', '30'],
          showTotal: (total, range) => {
            return range[0] + '-' + range[1] + ' 共' + total + '条';
          },
          showQuickJumper: true,
          showSizeChanger: true,
          total: 0
        },
        //--------列表页重复代码 end-------------
        benefitTypeOptions:[],
        // 表头
        columns,
        url: {
          list: process.env.VUE_APP_CMS_CUSTOMER + "/member/ctMmBenefits/list",
          statusArticle: process.env.VUE_APP_CMS_CUSTOMER + "/member/ctMmBenefits/updateStatus",
          delete: process.env.VUE_APP_CMS_CUSTOMER + "/member/ctMmBenefits/delete"
        },
      }
    },
    created() {
      this.loadData(1);
      this.initDictConfig();
    },
    methods: {
      getIconView: function(icon) {
        return getFileAccessHttpUrl(icon);
      },
      handleStatusArticle(checked, record) {
        let status = checked ? 0 : 1;
        record.statusFlg = status;
        postAction(this.url.statusArticle, {
          id: record.id,
          status: checked ? 0 : 1
        }).then(res => {
          if (res.success) {
            this.loadData();
            this.$message.success(res.message);
          } else {
            this.$message.error(res.message);
          }
        });
      },
      initDictConfig() {
        console.log('--我才是真的方法!--');
        //初始化字典 - 客户类型
        initDictOptions('benefit_type').then(res => {
          if (res.success) {
            this.benefitTypeOptions = res.result;
          }
        });
      },
      //-----------------列表页重复代码-开始--------------
      //分页
      handleTableChange(pagination, filters, sorter) {
        this.onClearSelected(); //分页切换时清空表格选中
        //分页、排序、筛选变化时触发
        if (Object.keys(sorter).length > 0) {
          this.isorter.column = sorter.field;
          this.isorter.order = 'ascend' == sorter.order ? 'asc' : 'desc';
        }
        this.ipagination = pagination;
        this.loadData();
      },
      loadData(arg) {
        let that = this;
        if (arg === 1) {
          that.ipagination.current = 1;
        }
        let params = this.getQueryParams();
        getAction(this.url.list,params).then(res => {
          that.loading = true;
          if (res.success) {
            that.dataSource =
              res.result && res.result.records ? res.result.records : [];
            //额外处理start
            this.dataSource.forEach(item => {
              item.statusFlg = item.status == 0 ? true : false;
            });
            //额外处理end
            that.loading = false;
            that.ipagination.total = res.result.total;
          }
        });
      },
      getQueryParams() {
        let param = Object.assign(
          this.searchObj
        );

        param.field = this.getQueryField();
        param.pageNo = this.ipagination.current;
        param.pageSize = this.ipagination.pageSize;
        return filterObj(param);
      },
      getQueryField() {
        let str = 'id,';
        this.columns.forEach(function(value) {
          str += ',' + value.dataIndex;
        });
        return str;
      },
      handleAdd: function(course) {
        console.log(course);
        if (course) {
          if (course.type == 'click') {
            course = undefined;
          }
        }

        this.$refs.modalForm.add(course);
        this.$refs.modalForm.title = '新增';
        this.$refs.modalForm.disableSubmit = false;
      },
      handleEdit: function(record) {
        this.$refs.modalForm.edit(record);
        this.$refs.modalForm.title = '编辑';
        this.$refs.modalForm.disableSubmit = false;
      },
      handleDelete: function(id) {
        if (!this.url.delete) {
          this.$message.error('请设置url.delete属性!');
          return;
        }
        let that = this;
        getAction(that.url.delete, { id: id }).then(res => {
          if (res.success) {
            that.$message.success(res.message);
            that.loadData();
          } else {
            that.$message.warning(res.message);
          }
        });
      },
      modalFormOk() {
        // 新增/修改 成功时，重载列表
        this.loadData();
      },
      onSelectChange(selectedRowKeys, selectionRows) {
        this.selectedRowKeys = selectedRowKeys;
        this.selectionRows = selectionRows;
        console.log(this.name);
        if (this.name == 'courseManageModal') {
          let courseList = selectedRowKeys;
          this.form.setFieldsValue({
            courseList
          });
        }
      },
      onClearSelected() {
        this.selectedRowKeys = [];
        this.selectionRows = [];
      },
      searchQuery() {
        this.loadData(1);
      },
      //重置
      searchReset() {
        this.searchObj = {};
        this.loadData(1);
      }
      //-----------------列表页重复代码-结束--------------
    }
  }
</script>
<style scoped>
  @import '~@assets/less/common.less';
</style>